import React from 'react'
import { Modal } from 'antd'
import { AppleFilled } from '@ant-design/icons'

/**
 * Shows a modal explaining that web push notifications on iOS require
 * the app to be installed to the home screen (standalone/PWA mode).
 *
 * Triggered when a user attempts a preview send on iOS Safari (non-standalone).
 */
export function showIOSInstallPrompt(): void {
    Modal.info({
        title: 'Add to Home Screen Required',
        icon: <AppleFilled style={{ color: 'var(--color-primary-100)' }} />,
        content: (
            <div>
                <p style={{ marginBottom: 12 }}>
                    To receive push notification previews on this device, you need to install this app to your home
                    screen.
                </p>
                <ol style={{ paddingLeft: 20, margin: 0 }}>
                    <li>
                        Tap the <strong>Share</strong> button in Safari (the square with an arrow)
                    </li>
                    <li>
                        Scroll down and tap <strong>Add to Home Screen</strong>
                    </li>
                    <li>
                        Tap <strong>Add</strong> to confirm
                    </li>
                    <li>Open the app from your home screen and try again</li>
                </ol>
                <p style={{ marginTop: 12, color: 'var(--color-gray-dark)', fontSize: 12 }}>
                    This is an iOS requirement — web push notifications only work when the site is launched from the
                    home screen.
                </p>
            </div>
        ),
        okText: 'Got it',
        width: 360,
    })
}
